module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAACXBIWXMAAAsSAAALEgHS3X78AAABDUlEQVQ4ja2UsXHDIBSGP6kIrbrQmWzgEXTRAskGGcEreANt4BGiBbhLNpAmiNxR2iUVKYJygGVizvkbwfsf373Tg1c558hJyO4F2AKjNXrI5VY5mAe9B6HXHLDOlgX9H/vbYEJ2b8AmCW98/HaYkN0OOFw5c/D+hSrn3PJvdoBaqSanIzADvTV6qB4enxXwVQC4pqfaV/MfUrU1+gOY7gRNwLg0oL0DOAGtNfr0e2mF7BpgpLwBW2v0CYKr4QPZ57KiYQFFsMUshYWbFNYWwqL8FKYKYVF+CmtWDhyBT/9NFeWnsB44+/UZ2FujlTW6tUYrYJ/40RS5mGdCdsqXP4adCvyGn2E5W6Pn0PsGXJtekmJnbOsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/full-star.png
// module id = 4
// module chunks = 0